/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InstanceBulkActionLead } from './InstanceBulkActionLead';
import {
    InstanceBulkActionLeadFromJSON,
    InstanceBulkActionLeadFromJSONTyped,
    InstanceBulkActionLeadToJSON,
    InstanceBulkActionLeadToJSONTyped,
} from './InstanceBulkActionLead';

/**
 * 
 * @export
 * @interface InstanceBulkActionExcludedInstance
 */
export interface InstanceBulkActionExcludedInstance {
    /**
     * 
     */
    lead: InstanceBulkActionLead;
    /**
     * 
     */
    reason: string;
    /**
     * 
     */
    reason_code: InstanceBulkActionExcludedInstanceReasonCodeEnum;
}


/**
 * @export
 */
export const InstanceBulkActionExcludedInstanceReasonCodeEnum = {
    FinalDecision: 'final_decision',
    AlreadyDeclined: 'already_declined',
    HasAdmissionStatus: 'has_admission_status',
    DifferentSource: 'different_source',
    IntegrationDisabled: 'integration_disabled',
} as const;
export type InstanceBulkActionExcludedInstanceReasonCodeEnum = typeof InstanceBulkActionExcludedInstanceReasonCodeEnum[keyof typeof InstanceBulkActionExcludedInstanceReasonCodeEnum];


/**
 * Check if a given object implements the InstanceBulkActionExcludedInstance interface.
 */
export function instanceOfInstanceBulkActionExcludedInstance(value: object): value is InstanceBulkActionExcludedInstance {
    if (!('lead' in value) || value['lead'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('reason_code' in value) || value['reason_code'] === undefined) return false;
    return true;
}

export function InstanceBulkActionExcludedInstanceFromJSON(json: any): InstanceBulkActionExcludedInstance {
    return InstanceBulkActionExcludedInstanceFromJSONTyped(json, false);
}

export function InstanceBulkActionExcludedInstanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkActionExcludedInstance {
    if (json == null) {
        return json;
    }
    return {
        
        'lead': InstanceBulkActionLeadFromJSON(json['lead']),
        'reason': json['reason'],
        'reason_code': json['reason_code'],
    };
}

export function InstanceBulkActionExcludedInstanceToJSON(json: any): InstanceBulkActionExcludedInstance {
    return InstanceBulkActionExcludedInstanceToJSONTyped(json, false);
}

export function InstanceBulkActionExcludedInstanceToJSONTyped(value?: InstanceBulkActionExcludedInstance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead': InstanceBulkActionLeadToJSON(value['lead']),
        'reason': value['reason'],
        'reason_code': value['reason_code'],
    };
}

